const reports = {
    TRANSACTIONS: '/transactions-report',
  }
  
  export default reports